/**
 * Opacity Primitives — raw opacity values.
 */

export const opacityValues = {
  subtle: "0.25",
  disabled: "0.4",
  muted: "0.5",
  hover: "0.75",
  loading: "0.8",
} as const;
